import template from './admin_only_download_ids.template.html?raw';

angular
  .module('peopleSearch.components.adminOnlyDownloadIds', [])
  .run(['$templateCache', function ($templateCache) {
    $templateCache.put(template, template);
  }])
  .component('adminOnlyDownloadIds', {
    bindings: {
      searchUrl: '<',
    },
    controllerAs: 'vm',
    templateUrl: template,
    controller: function () {
      var that = this;
      that.flags = {
        isProcessing: false,
        successMessage: false,
      };
      that.csvResultsEndpoint = '/api/public/search/csv_results';

      /**
       * When admin user clicks on button to download ID's, copy SearchJS object to get recent
       * filters, run a search to the BE and change UI accordingly
       *
       * @returns {Promise} Promise that can be extended using the regular callbacks
       */
      that.downloadIds = () => {
        that.flags.successMessage = false;
        that.flags.isProcessing = true;
        const searchJsParams = that.searchUrl.split('?')[1];

        return fetch(`${that.csvResultsEndpoint}?${searchJsParams}`)
          .then(() => {
            that.flags.successMessage = true;
            that.flags.isProcessing = false;
          })
          .catch(() => {
            that.flags.isProcessing = false;
          });
      };
    },
  });

